import { type Epic } from 'redux-observable';
import { filter } from 'rxjs';
import { request } from '@/core';
import { editIncidentRequest } from '@/api/events';
import { editIncident } from '../actions';

const editIncidentEpic: Epic = (action$) =>
  action$.pipe(
    filter(editIncident.match),
    request(({ payload }) => editIncidentRequest(payload), editIncident),
  );

export default editIncidentEpic;
